module.exports = __webpack_public_path__ + "img/about_img.92313486.png";